import React, { useEffect } from "react";
import "./Report.css";
import ReportHeader from "../../components/reportheader/reportheader";
import { useSmarkState } from "../../Context/KeycloakContext";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const Report = () => {
  const contextDetails = useSmarkState();
  const history = useHistory();

  /* ================= PERMISSION CHECK ================= */

  const projectPermissions =
    JSON.parse(localStorage.getItem("projectPermissions")) || {};

  const isGlobalAdmin =
    JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

  
  const hasGRPermission =
    isGlobalAdmin ||
    Object.values(projectPermissions).some(perms =>
      perms.includes("GR")
    );

  
  useEffect(() => {
    if (!hasGRPermission) {
      history.replace("/dashboard");
      toast.error("You are not authorized to access Report feature.");
    }
  }, [hasGRPermission, history]);

  
  if (!hasGRPermission) {
    return null;
  }

  /* ================= RENDER ================= */

  return (
    <div>
      <ReportHeader
        isAdmin={contextDetails.isAdminUser}
        userId={contextDetails.userId}
      />
    </div>
  );
};

export default Report;
